import { z } from "zod";
import { PaginatedSearchSchema } from "./paginated-search";

export const BlModifiedFranceOrderSearchSchema = PaginatedSearchSchema.extend({
  sort: z
    .enum([
      "code.asc",
      "code.desc",
      "submissionDate.asc",
      "submissionDate.desc",
      "customerLastname.asc",
      "customerLastname.desc",
      "labName.asc",
      "labName.desc",
      "riderName.asc",
      "riderName.desc",
    ])
    .optional(),
});
